@if (flags.loading) {
  <mat-progress-bar mode="indeterminate" [class.iosProgress]="utils.ios()"></mat-progress-bar>
}
@if (posts) {
  @if (posts.length != 0) {
    <div>
      <div class="resultsHeader" [class.on]="searchStr != null"><mat-icon>date_range</mat-icon> Events</div>
    </div>
  }
  <div class="squaresContainer" (swipeleft)="swipeLeft()">
    @for (post of posts; track post; let i = $index) {
      @if (utils.showPremium(user) || !post?.price || post?.price == 0 || post?.price == '0' || post?.price == '0.00' || post?.price === 'Free') {
        <a class="backgroundSquares fadeIn"
          [style.background-image]="'url(' + displayImage(post) + ')'"
          [@zoomBack]=$safeNavigationMigration(user?.app_state?.homeBackground) [routerLink]="'/' + $safeNavigationMigration(post.creator?.username) + '/' + post.id"
          [style.animation-delay]="'0.' +post?.meta?.timing + 's'" (click)="utils.sound('click-face')" [class.one]="nth(i,3)" [class.three]="nth(i+1,3)">
          <div fxlayout="row">
            @if (utils.showPremium(user)) {
              <div class="price">{{utils.displayPrice(post)}}</div>
            }
            <div class="title">
              @if (!router.url.includes('/activity/')) {
                <span><b>{{ post?.activity?.name }}</b> </span>
                }<br />
                <span>{{ utils.humanDate($safeNavigationMigration(post?.datetime)) }} </span>
                @if (utils.humanDate($safeNavigationMigration(post?.datetime)) != 'Today' && utils.humanDate($safeNavigationMigration(post?.datetime)) != 'Tomorrow') {
                  <span>{{ $safeNavigationMigration(post?.datetime)|date:'MM/dd' }}</span>
                }
                @if (!post?.meta?.past) {
                  <br />&#64;
                  @if (!utils.isNoon($safeNavigationMigration(post?.datetime))) {
                    <span>{{ $safeNavigationMigration(post?.datetime)|date:'shortTime' }}</span>
                  }
                  @if (utils.isNoon($safeNavigationMigration(post?.datetime))) {
                    <span>Noon</span>
                  }
                }
              </div>
              @if (post?.activity?.is_premium) {
                <mat-icon class="premium">star</mat-icon>
              }
              <!-- <button mat-button class="help" (click)="openExternal(post?.url)" *ngIf="post?.url != null"><mat-icon>help</mat-icon></button> -->
              <!-- <div class="pill">{{ post?.creator?.full_name }}</div> -->
            </div>
          </a>
        }
      }
    </div>
    @if (searchStr == null && flags.noResults && !flags.loading) {
      <div class="noResults">
        <h2><mat-icon>date_range</mat-icon></h2>
        <h5>No more posts found</h5>
        <br /><br />
        @if (searchStr) {
          <button mat-button routerLink="/posts" onclick="window.scrollTo(0,0)" (click)="back();searchStr=null;getPosts()"><mat-icon>arrow_back</mat-icon> Back</button>
        }
        <br /><br />
      </div>
    }
  }
